import {createLargeRegion} from './large-markup-region';
import {createSmallRegion} from './small-markup-region';

export const createMarkupRegion = (region, viewport) => {
  const factory = region.getMarkupInfo().isSmall ? createSmallRegion : createLargeRegion;
  return factory(region, viewport);
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/image-analysis/markup/markup-region-factory.js